import { useLayoutEffect, useRef } from "react";
// Tailwind safelist: focus-within:border-[#1D1D1F] focus-within:border-sky-500
import { digitsOnly, isianTelepon, sisaTelepon } from "../lib/phone";

// Posisi kursor sesudah n angka di teks berformat.
const posSesudahAngka = (teks, n) => {
  if (n <= 0) return 0;
  let hit = 0;
  for (let i = 0; i < teks.length; i += 1) {
    if (/\d/.test(teks[i])) hit += 1;
    if (hit === n) return i + 1;
  }
  return teks.length;
};

/** Kolom telepon dengan awalan tetap "(+62)"; nilai = isian berformat "812-3456-7890". */
export function PhoneInput({ value, onChange, onBlur, className = "", inputClassName = "", prefixStyle, prefixClassName = "shrink-0 select-none", awalan = "(+62)",
  placeholder = "812-3456-7890", ...rest }) {
  const ref = useRef(null);
  const caret = useRef(null);
  const tampil = isianTelepon(value);

  useLayoutEffect(() => {
    if (caret.current == null || !ref.current) return;
    ref.current.setSelectionRange(caret.current, caret.current);
    caret.current = null;
  });

  const terapkan = (mentah, angkaSebelumKursor) => {
    const semua = digitsOnly(mentah);
    const sisa = sisaTelepon(mentah);
    const n = Math.max(0, angkaSebelumKursor - (semua.length - sisa.length));
    const baru = isianTelepon(sisa);
    caret.current = posSesudahAngka(baru, n);
    onChange(baru);
  };

  const ubah = (e) => {
    const el = e.target;
    terapkan(el.value, digitsOnly(el.value.slice(0, el.selectionStart ?? el.value.length)).length);
  };

  // Hapus melewati tanda hubung: hapus angka di sebelahnya, bukan tanda hubungnya saja.
  const tombol = (e) => {
    const el = e.target;
    const s = el.selectionStart;
    if (s !== el.selectionEnd) return;
    if (e.key === "Backspace" && s > 1 && tampil[s - 1] === "-") {
      e.preventDefault();
      terapkan(tampil.slice(0, s - 2) + tampil.slice(s), digitsOnly(tampil.slice(0, s - 2)).length);
    } else if (e.key === "Delete" && tampil[s] === "-") {
      e.preventDefault();
      terapkan(tampil.slice(0, s + 1) + tampil.slice(s + 2), digitsOnly(tampil.slice(0, s)).length);
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className.replace(/(^|\s)focus:/g, "$1focus-within:")}`} onClick={() => ref.current?.focus()}>
      <span className={prefixClassName} style={prefixStyle} aria-hidden="true">{awalan}</span>
      <input ref={ref} type="tel" inputMode="tel" autoComplete="tel" value={tampil} onChange={ubah}
        onKeyDown={tombol} onBlur={onBlur} placeholder={placeholder}
        className={`flex-1 min-w-0 bg-transparent border-0 outline-none p-0 ${inputClassName}`}
        style={{ font: "inherit", color: "inherit", border: 0, boxShadow: "none", background: "transparent", padding: 0, margin: 0, height: "auto", minHeight: 0 }} {...rest} />
    </div>
  );
}
